import { createSelector } from 'reselect'
import Immutable from 'immutable'

import {
  getExternals,
  handleExternals,
} from 'internal-components/src/redux/modules/signup/selectors'

export const selectEditSignupWithExternals = createSelector(
  [state => Immutable.Set([state.signupEdit.get('edit')]), ...getExternals],
  (signups, ...data) => {
    if (!signups.size || !signups.first()) {
      return null
    }

    return handleExternals(signups, ...data).first()
  },
)

export const selectErrorsByPath = createSelector(
  state => state.get('errors'),
  errors => errors.groupBy(error => error.get('path')),
)

export const makeSelectQualificationResults = () =>
  createSelector(
    state => state.signupEdit,
    signupEdit => signupEdit.getIn(['meta', 'qualificationResults']),
  )



// WEBPACK FOOTER //
// ./src/redux/modules/signupEdit/selectors.js